import React, {Component} from 'react';
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {withStyles} from "@material-ui/core/styles";
import moment from "moment";
import Button from "@material-ui/core/Button/Button";

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  summaryContent: {
    flexWrap: 'wrap'
  }
});

class DepartmentUnScoredCriteriaOfAStore extends Component {

  constructor(props){
    super(props);

    this.state = {
      expanded: null,
    };

  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render(){
    const {classes} = this.props;
    const {expanded} = this.state;
    let unScoredCriteria = [];
    if(this.props.selectedStore){
      unScoredCriteria = this.props._getStoreUnScoredCriteria(this.props.selectedStore);
    }
    return (
      <div>
        <Typography color="inherit" variant="h6" className={'mb-3'}>
          {`Unscored criteria (Store: ${this.props.selectedStore.name})`}
        </Typography>
        {
          unScoredCriteria.map(criterion => (
            <ExpansionPanel
              key={criterion.id}
              expanded={expanded === criterion.id}
              onChange={this.handleChange(criterion.id)}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{content: classes.summaryContent}}>
                <Typography className={classes.heading}>{criterion.name}</Typography>
                <Typography className={classes.secondaryHeading}>
                  {moment(criterion.createdDate).format('DD/MM/YYYY HH:mm:ss')}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Table >
                  <TableBody>
                    <TableRow >
                      <TableCell  component="th" scope="row">{'Id'}</TableCell>
                      <TableCell>{criterion.id}</TableCell>
                    </TableRow>
                    <TableRow >
                      <TableCell  component="th" scope="row">{'Code'}</TableCell>
                      <TableCell>{criterion.code}</TableCell>
                    </TableRow>
                    <TableRow >
                      <TableCell  component="th" scope="row">{'Εξάμηνη βαρύτητα'}</TableCell>
                      <TableCell>{criterion.weightOld}</TableCell>
                    </TableRow>
                    <TableRow >
                      <TableCell  component="th" scope="row">{'Βαρύτητα νέων καταστημάτων'}</TableCell>
                      <TableCell>{criterion.weightNew}</TableCell>
                    </TableRow>
                    <TableRow >
                      <TableCell  component="th" scope="row">{'Βαρύτητα υφιστάμενων καταστημάτων'}</TableCell>
                      <TableCell>{criterion.weightNewComing}</TableCell>
                    </TableRow>
                    <TableRow >
                      <TableCell  component="th" scope="row">{'Created Date'}</TableCell>
                      <TableCell>{moment(criterion.createdDate).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))
        }
        <Button
          onClick={this.props.closePendingCriteriaModal}
          variant="contained" color="secondary" className={'mt-3 custom-modal__btn'}
        >
          {'Close'}
        </Button>
      </div>

    )
  }
}

export default withStyles(styles)(DepartmentUnScoredCriteriaOfAStore);




// WEBPACK FOOTER //
// ./src/components/department/departmentUnScoredCriteriaOfAStore.js